import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import withErrorHandler from '../hoc/withErrorHandler/withErrorHandler';

import AdminDropMenu from '../../components/UI/AdminDropMenu/AdminDropMenu';

import AddDropButton from '../../components/UI/Buttons/AddDropButton/AddDropButton';
import OpenArchiveButton from '../../components/UI/Buttons/OpenArchiveButton/OpenArchiveButton';
import Spinner from '../../components/UI/Spinner/Spinner';
import Aux from '../hoc/Auxiliary';

import classes from './AdminConsole.css';
import axios from '../../axios-drops';


class AdminConsole extends Component {

    state = {
        currentDrops: [],
        pastDrops: [],
        loaded: false
    }


    componentDidMount() {
        window.scrollTo(0, 0)

        const func = async () => {
            await axios.get('/drops.json')
            .then(response => {
                const fetchedCurrentDrops = []

                const fetchedPastDrops = []
                for (let key in response.data) {
                    
                    if (response.data[key].current) {

                        fetchedCurrentDrops.push({
                            ...response.data[key],
                            id: key
                        })
                    } else {
           
                        fetchedPastDrops.push({
                            ...response.data[key],
                            id: key
                        })
                    }
                }

                let reducedPastDrops = []
                fetchedPastDrops.reverse()

                if (fetchedPastDrops.length > 4) {
                    for (let i = 0; i < 5; ++i) {
                        reducedPastDrops.push({
                            ...fetchedPastDrops[i]
                        })
                    }
                    this.setState({currentDrops: fetchedCurrentDrops,
                        pastDrops: reducedPastDrops,
                        loaded: true

                    })
                } 
                else {
                    this.setState({currentDrops: fetchedCurrentDrops,
                        pastDrops: fetchedPastDrops,
                        loaded: true
                    })
                }
 
            })
            .catch(err => {
                this.setState({
                    loaded: true
                })
            })
        }

        
        func()
   
            

    }

    openMenuHandler = (id) => {
        this.props.history.push({
            pathname: '/admin/focus/trd/' + id
            ,lastPage:'console'
        })
    }


    render() {


        let currentDropsGroup = <p className={classes.AddDrop}><Link to="/addPinTrd" className={classes.CreateDrop}>Create a Drop</Link></p>;
        let pastDropsGroup = <p className={classes.AddDrop}>No Past Drops Exist Yet</p>

        if (this.state.currentDrops.length > 0) {
            currentDropsGroup = (<div className={classes.DropMenu}>
                {this.state.currentDrops.map((drop, index) => (
                      
                    <AdminDropMenu
                        key={drop.id}
                        click={() => this.openMenuHandler(drop.id)}
                        image={drop.image}
                        name={drop.name}
                        variant={drop.variant}
                        edition={drop.edition} 
                        cost={drop.cost}
                        numberAvailable={drop.availability}
                        originallyAvailable={drop.originallyAvailable}
                        current={true}
                        archive={false}
                        type={drop.type}
                        id={drop.id}
                        />
                ))}
            </div>)
        }

        if (this.state.pastDrops.length > 0) {
            pastDropsGroup = (<div className={classes.DropMenu}>
                {this.state.pastDrops.map((drop, index) => (
                    
                    <AdminDropMenu
                        key={drop.id}
                        click={() => this.openMenuHandler(drop.id)}
                        image={drop.image}
                        name={drop.name}
                        variant={drop.variant}
                        edition={drop.edition} 
                        cost={drop.cost}
                        numberAvailable={drop.availability }
                        originallyAvailable={drop.originallyAvailable}
                        current={false}
                        archive={false}
                        type={drop.type}
                        id={drop.id}
                        />
                    
                ))}
            </div>)
        }

        let authRedirect = null
        if (!this.props.isAuth) {
            authRedirect = <Redirect to="/signin"/>
        }

        let adminPage = (
            <div className={classes.Spinner}>
                <Spinner />
            </div>
        )


        if (this.state.currentDrops.length > 0 || this.state.pastDrops.length > 0 || this.state.loaded) {
            adminPage = (
                <div className={classes.AdminConsole} >
                    {authRedirect}
                    <h3 className={classes.Title}>The Drop Console</h3>
                    <hr></hr>
                    <div className={classes.CurrentDropTitleSection}>
                        <h1 className={classes.SubTitleOne}>Current Drops</h1>
                        <AddDropButton 
                            className={classes.AddButton}
                            linkName={'/addPinTrd'} 
                            disabled={false}
                            />
                    </div>
                    {currentDropsGroup}
                    <div className={classes.BottomLine}></div>
                    <hr></hr>
                    <div className={classes.PastDropTitleSection}>
                        <h1 className={classes.SubTitleTwo}>Past Drops</h1>
                        <OpenArchiveButton
                            linkName={'/admin/archive/trd'}
                            disabled={false} />
                    </div>
                    
                    {pastDropsGroup}
                </div>
            )
        }

      
        return (
            <Aux>
                {adminPage}
            </Aux>
            
        )
    }
    
}

const mapStateToProps = state => {
    return {
        isAuth: state.token !== null 
    }
}


export default connect(mapStateToProps)(withErrorHandler(AdminConsole, axios))


// WEBPACK FOOTER //
// ./src/containers/AdminConsole/AdminConsole.js